export enum MappingMode {
  New = 0,
  Mapped = 1,
  Saved = 2,
  Omitted = 3,
  Accepted,
	Assigned,
	FixMapping,
	ReAssigned  ,
}

export enum MappingAction {
  Clear = 0, // 'clear',
  Omit = 1, // 'omit',
  Save = 2, // 'save',
  Map = 3, // 'map',
  Accept = 4, // 'accept',
  Review = 5, // 'review',
  AcceptMapping = 6, // 'acceptMapping',
  MapAsService = 7, // 'mapAsService',
  Deactivate = 8, // 'deactivate',
  Reactivate = 9, // 'reactivate',
  OmitBarcode = 10, // 'omitBarcode',
  SaveBarcode = 11, // 'saveBarcode'
  MapAsProduct = 12, // 'mapAsProduct'
	ReAssign = 13,
	Assign = 14,
	FixMapping = 15,
}

export enum UserAction {
	Deactivate = 0,
	Reactivate = 1,
	Promote = 2,
	Demote = 3
}
